<template>
  <!-- 外部提成人审批流程详情 -->
  <div class="bid-follow-process-detail">
    <div class="title">{{details.TemplateID===16?`负责人折扣申请审批进度（ ${details.Code} ）`:`外部提成人审批进度（ ${details.Code} ）`}}</div>
    <div v-if="JSON.stringify(details) != '{}'">
      <sub-title :title="details.TemplateID===16?'负责人折扣信息':'申请信息'"></sub-title>
      <div class="details-table">
        <div class="details-box-item">
          <div class="details-box-item">
            <div class="item-left">负责人：</div>
            <div
              class="item-right"
            >{{details.TemplateID===16?details.ExternalManagerName:details.Name}}</div>
          </div>
          <div class="details-box-item">
            <div class="item-left">联系电话：</div>
            <div class="item-right">{{details.Tel}}</div>
          </div>
          <div class="details-box-item">
            <div class="item-left">渠道来源：</div>
            <div class="item-right">{{details.ChannelSourceFrom}}</div>
          </div>
        </div>
        <div class="details-box-item">
          <div class="details-box-item">
            <div class="item-left">渠道类型：</div>
            <div class="item-right">{{details.ChannelCategory | orderTypeFilter}}</div>
          </div>
          <div class="details-box-item" v-if="details.TemplateID===14">
            <div class="item-left">提成类型：</div>
            <div class="item-right">{{details.CommissionType ? "订单创收" : "订单笔数"}}</div>
          </div>
          <div class="details-box-item" v-if="details.TemplateID===14">
            <div class="item-left">提成比例：</div>
            <div
              class="item-right"
            >{{details.CommissionType ? details.CommissionValue*100 : details.CommissionValue}} {{details.CommissionType ? '%' : '元/笔'}}</div>
          </div>
          <div class="details-box-item" v-if="details.TemplateID===16">
            <div class="item-left">银行名称：</div>
            <el-tooltip
              class="item"
              effect="dark"
              :content="details.BankBranchList| bankFilters"
              placement="bottom"
              :disabled="details.BankBranchList.length>2?false:true"
            >
              <div
                class="item-right"
                style="white-space: nowrap;overflow:hidden;text-overflow:ellipsis"
              >{{ details.BankBranchList| bankFilters }}</div>
            </el-tooltip>
          </div>
          <div class="details-box-item" v-if="details.TemplateID===16">
            <div class="item-left">地区：</div>
            <el-tooltip
              class="item"
              effect="dark"
              :content="details.Areas"
              placement="bottom"
              :disabled="details.Areas | AreasFilters"
            >
              <div
                class="item-right"
                style="white-space: nowrap;overflow:hidden;text-overflow:ellipsis"
              >{{ details.Areas }}</div>
            </el-tooltip>
          </div>
        </div>
        <div class="details-box-item">
          <div class="details-box-item" v-if="details.TemplateID===16">
            <div class="item-left">有效期：</div>
            <div
              class="item-right"
            >{{$common.timesToTime(details.StartEffective)}}至{{$common.timesToTime(details.EndEffective) }}</div>
          </div>
          <div class="details-box-item" v-if="details.TemplateID===16">
            <div class="item-left">是否转开：</div>
            <div class="item-right">{{ details.TurnAround===0?'否':details.TurnAround===1?'是':'全部' }}</div>
          </div>
          <div class="details-box-item" v-if="details.TemplateID===16">
            <div class="item-left">阶梯算法：</div>
            <div class="item-right">
              <el-popover placement="left" trigger="hover" v-if="details.LadderData">
                <el-table :data="details.LadderData" border>
                  <el-table-column width="200" align="center" label="阶梯范围">
                    <template slot-scope="scope">
                      <span>{{ $common.moneyFormat(scope.row.MinMoney) }}</span>
                      <span>-</span>
                      <span>{{ $common.moneyFormat(scope.row.MaxMoney) }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column width="100" align="center" label="算法类型">
                    <template slot-scope="scope">
                      <span>{{ scope.row.LadderAlgType|priceAlgType }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column width="100" align="center" label="阶梯值">
                    <template slot-scope="scope">
                      <span>{{ scope.row.Value }}</span>
                    </template>
                  </el-table-column>
                </el-table>
                <i slot="reference" class="el-icon-s-grid" style="font-size: 18px;"></i>
              </el-popover>
              <span v-else>--</span>
            </div>
          </div>
          <div
            class="details-box-item"
            v-if="details.TemplateID===14&&details.ChannelCategory === 'CompanyChannel'"
          >
            <div class="item-left">所属企业：</div>
            <div class="item-right fileBox">{{details.CommissionCompanyName}}</div>
          </div>
          <div class="details-box-item" v-if="details.TemplateID===14">
            <div class="item-left">合同：</div>
            <div class="item-right fileBox">
              <template v-if="details.ContractFileId">
                <el-image
                  class="preview-img"
                  :src="/\.(?:pdf)/i.test(details.ContractFileId) ? '/static/picture/pdf-file-icon.png' : '/static/picture/word-file-icon.png'"
                />
                <el-link
                  type="primary"
                  class="link"
                  @click="previewEvent(details.ContractFileId)"
                >{{details.ContractFileId.split(":")[1]}}</el-link>
              </template>
            </div>
          </div>
          <div class="details-box-item" v-if="details.TemplateID===14">
            <div class="item-left">合同有效期：</div>
            <div
              class="item-right"
            >{{$common.timesToTime(details.ContractStratDate)}} - {{$common.timesToTime(details.ContractEndDate)}}</div>
          </div>
        </div>
      </div>
      <!-- 流程图 -->
      <sub-title title="审批进度" v-if="details.TemplateID===16"></sub-title>
      <flow-chart
        :details="details"
        :selTab="type"
        :TemplateID="TemplateID"
        @close="$emit('refresh')"
        v-if="JSON.stringify(details)!='{}'"
      />
    </div>
  </div>
</template>
<script>
import { WorkflowQuery, previewDocFile } from "@/http/api";
import { fetchSysDicList } from "@/http/dictionary";
var that;
export default {
  name: "OutsideCommissionPerson",
  props: {
    ID: {
      // 当前id
      type: Number,
      default: null
    },
    type: {
      type: String,
      default: ""
    },
    TemplateID: {
      // 流程ID
      type: Number,
      default: null
    }
  },
  data() {
    return {
      BASE_API: window.BASE_API,
      details: {},
      PriceAlgType: []
    };
  },
  watch: {
    ID: {
      handler(val, oldVal) {
        this.getDetails();
      },
      immediate: true
    }
  },
  filters: {
    orderTypeFilter(val) {
      const temp = that.$orderTeamTypes.find(item => item.Name == val);
      return (temp && temp.Title) || "";
    },
    bankFilters(bank) {
      let temp = "";
      bank.forEach(item => {
        return (temp += item.Name + ";");
      });
      return temp;
    },
    priceAlgType: function(type) {
      if (!isNaN(type) && that.PriceAlgType.length > 0) {
        return that.PriceAlgType.filter(item => item.Name == type)[0]["Title"];
      } else {
        return "";
      }
    },
    AreasFilters(str) {
      let arr = str.split(";");
      if (arr.length > 2) {
        return false;
      } else {
        return true;
      }
    }
  },
  created() {
    that = this;
    this.getPriceAlgType();
  },
  methods: {
    getDetails() {
      this.$emit("loading", true);
      WorkflowQuery(
        { workflowId: this.ID, templateId: this.TemplateID },
        "Get"
      ).then(res => {
        if (!!res && JSON.stringify(res) != "{}") {
          this.details = res;
        }
        this.$emit("loading", false);
      });
    },
    previewEvent(url) {
      // 预览docx文件
      if (/\.(?:docx|xlsx|xls)+(:\d*)*$/i.test(url)) {
        previewDocFile(url, true).then(res => window.open(res, "_blank"));
      } else if (/\.(?:pdf)+(:\d*)*$/i.test(url)) {
        // 预览pdf文件
        let pdf = encodeURIComponent(
          `${this.BASE_API}/Common.FileStore/GetFile/Performance?logicID=${url}`
        );
        window.open("/static/pdf/web/viewer.html?file=" + pdf, "PDF");
      } else {
        this.$message.error("该文件类型无法预览");
      }
    },
    //获取定价算法类型
    getPriceAlgType() {
      fetchSysDicList("BasicData", "PriceAlgType").then(res => {
        this.PriceAlgType = res;
      });
    }
  }
};
</script>
<style lang="less" scoped>
@import "./details.less";
.details-box-item {
  .details-box-item:nth-of-type(2) {
    .item-left {
      width: 126px;
    }
  }
  .details-box-item:nth-of-type(3) {
    .item-left {
      width: 126px;
    }
  }
}
</style>